// Core
import { http } from "@/network/http-provider";

export type PublicConfigResponse = {
  country: string;
  cashbackList: string[];
};

export const configApi = Object.freeze({
  fetchConfig: () => http.get<PublicConfigResponse>("/public/config"),
});
